import { ReactNode } from 'react';
import { Tooltip } from '@client/new/components/basic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { rgb } from '@design-system/tokens';
import * as styles from './InfoTooltip.css';

export type InfoTooltipProps = {
  ariaLabel: string;
  children: ReactNode;
};

export const InfoTooltip = ({ ariaLabel, children }: InfoTooltipProps) => (
  <Tooltip
    title={<div className={styles.content}>{children}</div>}
    placement="bottom"
    arrow
    componentsProps={{
      tooltip: {
        sx: {
          bgcolor: rgb('N-100'),
          color: rgb('N-20'),
          fontSize: '12px',
          lineHeight: '16px',
          fontWeight: 500,
          fontFamily: 'inherit',
          borderRadius: '4px',
          maxWidth: '220px',
          px: '8px',
          py: '4px',
        },
      },
      arrow: { sx: { color: rgb('N-100') } },
    }}
  >
    <FontAwesomeIcon
      icon={faInfoCircle}
      className={styles.icon}
      tabIndex={0}
      role="button"
      aria-label={ariaLabel}
    />
  </Tooltip>
);
